import React from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import { TextField as TextFieldComponent, H2 } from '~/components';
import { AsideBase } from '~/layout';
import { useApiIdentityByProfileId, useApiIdentityById } from '~/hooks/apiIdentity';
import { ApiIdentity } from '~/types/apiIdentity';
import { Individual, Employee } from '~/types';

const useStyles = makeStyles(() => ({
  identityValue: {
    display: 'inline-block',
    maxWidth: '90%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'bottom',
  },
}));

const l = (key: string): string => `components.ApiIdentityAside.${key}`;

interface Props {
  record?: Individual | Employee;
  resource: 'individuals' | 'employees';
}

const ApiIdentityAside = (props: Props) => {
  const { record, resource } = props;
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const isEmployee = resource === 'employees';
  const employeeRecord = isEmployee ? (record as Employee) : undefined;

  const { data: profileApiIdentities } = useApiIdentityByProfileId({
    profileId: isEmployee ? undefined : record?.id,
  });
  const { data: generalIdentity } = useApiIdentityById({
    identityId: employeeRecord?.generalIdentityId,
  }) as { data: ApiIdentity | undefined };
  const { data: cashierIdentity } = useApiIdentityById({
    identityId: employeeRecord?.cashierIdentityId,
  }) as { data: ApiIdentity | undefined };

  const apiIdentities: ApiIdentity[] | undefined = isEmployee
    ? [generalIdentity, cashierIdentity].filter((identity): identity is ApiIdentity => !!identity)
    : profileApiIdentities;

  if (!apiIdentities?.length) return null;

  return (
    <div>
      <H2 topSpacing={0} bottomSpacing={1}>
        {t('identities')}
      </H2>
      <AsideBase>
        <Grid container spacing={2}>
          {apiIdentities.map((apiIdentity) => (
            <Grid item xs={12} key={apiIdentity.id}>
              <TextFieldComponent
                label={t('identity')}
                icon={<FingerprintIcon />}
                showLink={`/apiIdentities/${apiIdentity.id}/show`}
                title={
                  apiIdentity.username ||
                  apiIdentity.name ||
                  apiIdentity.emailAddress ||
                  apiIdentity.phoneNumber
                }
              >
                <span className={classes.identityValue}>
                  {apiIdentity.username ||
                    apiIdentity.name ||
                    apiIdentity.emailAddress ||
                    apiIdentity.phoneNumber}
                </span>
              </TextFieldComponent>
            </Grid>
          ))}
        </Grid>
      </AsideBase>
    </div>
  );
};

export default ApiIdentityAside;
